import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Skeleton,
  SkeletonBlock,
  SkeletonContent,
  SkeletonLine
} from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';

const GroupItemPlaceHolder = ({ placeHolderConfig }) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const { height, numberOfLines } = placeHolderConfig;

  return (
    <Skeleton data-testid="group-item-placeholder" disablePadding="y" grow orientation="horizontal">
      <SkeletonContent density="loose" disablePadding="x" initialSize={isMobile ? '2/4' : '1/4'}>
        <SkeletonBlock height={height} aspect="wide" />
      </SkeletonContent>
      <SkeletonContent density="loose" disablePadding="x" initialSize={isMobile ? '2/4' : '3/4'}>
        <SkeletonLine numberOfLines={numberOfLines} />
      </SkeletonContent>
    </Skeleton>
  );
};

GroupItemPlaceHolder.displayName = 'GroupItemPlaceHolder';

GroupItemPlaceHolder.propTypes = {
  placeHolderConfig: PropTypes.shape({
    height: PropTypes.number,
    numberOfLines: PropTypes.number,
  }),
};

GroupItemPlaceHolder.defaultProps = {
  placeHolderConfig: {
    height: 32,
    numberOfLines: 3,
  },
};

export { GroupItemPlaceHolder };
